import { UserNotification } from "../../../@types/Users";
import { getTimeDiferenceTitle } from "../../../utils";
import { MdOutlineMarkEmailUnread } from "react-icons/md";
import { projectPrimaryColor } from "../../../generalConfigs";
import { IoMailOpenOutline } from "react-icons/io5";

type Props = {
  notification: UserNotification;
  handleOneClick: CallableFunction;
};

export function NotificationBody({ notification, handleOneClick }: Props) {
  const { created_at, title, is_read } = notification;
  const iconSize = 20;

  return (
    <div
      className="media new no-clicable-action"
      onClick={() => handleOneClick()}
    >
      {is_read ? (
        <IoMailOpenOutline size={iconSize} className="no-clicable-action" />
      ) : (
        <MdOutlineMarkEmailUnread
          color={projectPrimaryColor}
          size={iconSize}
          className="no-clicable-action"
        />
      )}

      <div className="media-body no-clicable-action">
        <p>{title}</p>
        <span>Há {getTimeDiferenceTitle(created_at)}</span>
      </div>
    </div>
  );
}
